<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export default {
  name: "App"
};
</script>

<style src="./css/style.css"></style>
